module.exports = __webpack_public_path__ + "static/media/night-sleep.475ced04.svg";